import {
  getPageBrand,
  isPageAllowedForBrandAccess,
} from '../config/page-brand-registry'

export const WYSEHUB_ACCESS_ROLE = 'WyseHub Access'
export const AICLAIMS_ACCESS_ROLE = 'AiClaims Access'
export const SYSTEM_ADMINISTRATOR_ROLE = 'System Administrator'

export type BrandAccessValue = 'wysehub' | 'aiclaims' | 'both'

type BrandAccessUser = {
  brandAccess?: string | null
  rolenames?: readonly string[] | null
} | null | undefined

/**
 * Role-derived product ceiling with column fallback (matches backend
 * ``effective_brand_access``). System Administrator → both.
 */
export function effectiveBrandAccess(user: BrandAccessUser): BrandAccessValue {
  const roles = user?.rolenames ?? []
  if (roles.includes(SYSTEM_ADMINISTRATOR_ROLE)) {
    return 'both'
  }
  const hasWysehub = roles.includes(WYSEHUB_ACCESS_ROLE)
  const hasAiclaims = roles.includes(AICLAIMS_ACCESS_ROLE)
  if (hasWysehub && hasAiclaims) {
    return 'both'
  }
  if (hasAiclaims) {
    return 'aiclaims'
  }
  if (hasWysehub) {
    return 'wysehub'
  }
  const ba = (user?.brandAccess || 'wysehub').toLowerCase()
  if (ba === 'aiclaims' || ba === 'both' || ba === 'wysehub') {
    return ba
  }
  return 'wysehub'
}

/**
 * Effective page access: RBAC grant (my-pages) and brand ceiling (Option A).
 */
export function canAccessPageForUser(
  pageKey: string,
  brandAccess: string | null | undefined,
  allowedPages: readonly string[],
): boolean {
  if (!allowedPages.includes(pageKey)) {
    return false
  }
  return isPageAllowedForBrandAccess(pageKey, brandAccess)
}

export function canUseAiClaimsProduct(
  brandAccess: string | null | undefined,
): boolean {
  return brandAccess === 'aiclaims' || brandAccess === 'both'
}

export function resolvePageBrandForCatalog(
  pageKey: string,
  catalogBrand?: string | null,
): ReturnType<typeof getPageBrand> {
  if (
    catalogBrand === 'wysehub' ||
    catalogBrand === 'aiclaims' ||
    catalogBrand === 'global'
  ) {
    return catalogBrand
  }
  return getPageBrand(pageKey)
}
